import Vue from "vue";
import Router from "vue-router";
// import VueGtm from "vue-gtm";

import Home from "./views/Home.vue";
import DefaultTemplate from "./templates/Default.vue";

Vue.use(Router);

const vueRouter = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/guias-de-estudo",
      name: "articles",
      component: () => import("./views/Articles.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/artigo/:id/:slug",
      name: "article",
      component: () => import("./views/Article.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/conteudo-aberto/:course/:id",
      name: "free-lesson",
      component: () => import("./views/Lesson.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/sala-de-aula/:id/aula/:number",
      name: "lesson",
      component: () => import("./views/Lesson.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/sala-de-aula/ao-vivo",
      name: "live",
      component: () => import("./views/Live.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/sala-de-aula/ao-vivo/:id",
      name: "live-course",
      component: () => import("./views/LiveCourse.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/sala-de-aula/aulas",
      name: "lessons",
      component: () => import("./views/Lessons.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/sala-de-aula/freebies",
      name: "freebies",
      component: () => import("./views/Freebies.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/sala-de-aula/aulas/:tag",
      name: "tags",
      component: () => import("./views/Lessons.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/sala-de-aula/audios",
      name: "audios",
      component: () => import("./views/Audios.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/sala-de-aula/materiais",
      name: "materials",
      component: () => import("./views/Materials.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/cursos/meus-cursos",
      name: "my-courses",
      component: () => import("./views/MyCourses.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/academicos",
      name: "academics",
      component: () => import("./views/Academics.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/cursos/catalogo",
      name: "catalog",
      component: () => import("./views/AllCourses.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/cursos/:id/:slug/detalhes",
      name: "course-details",
      component: () => import("./views/CourseDetails.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/cursos/:id/:slug",
      name: "course-lessons",
      component: () => import("./views/CourseLessons.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/cursos/:id/:slug/aula/:lesson",
      name: "course-lesson",
      component: () => import("./views/CourseLesson.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/minha-conta",
      name: "account",
      component: () => import("./views/Account.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/perfil",
      name: "profile",
      component: () => import("./views/Profile.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/mudanca-plano",
      name: "plan-change",
      component: () => import("./views/PlanChange.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/planos",
      name: "plans",
      component: () => import("./views/Plans.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/checkout",
      name: "checkout",
      component: () => import("./views/Checkout.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },

    {
      path: "/cadastro",
      name: "register",
      component: () => import("./views/Register.vue"),
      meta: {
        template: () => import("./templates/Auth.vue"),
        protected: false
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue"),
      meta: {
        template: () => import("./templates/Auth.vue"),
        protected: false
      }
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: () => import("./views/ResetPassword.vue"),
      meta: {
        template: () => import("./templates/Auth.vue"),
        protected: false
      }
    },
    {
      path: "/termos-de-uso",
      name: "terms",
      component: () => import("./views/Terms.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    },
    {
      path: "/politica-de-privacidade",
      name: "privacy",
      component: () => import("./views/Privacy.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    },
    {
      path: "/wpp",
      name: "whatsapp-redirect",
      component: () => import("./views/WppRedirect.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    },
    {
      path: "/whats_perpetuo",
      name: "whatsapp-redirect-perpetuo",
      component: () => import("./views/WppRedirectPerpetuo.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("./views/NotFound.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    }
  ]
});

// Vue.use(VueGtm, {
//   id: "GTM-TB4VDDF",
//   vueRouter
// });

export default vueRouter;
